import { render, staticRenderFns } from "./GoogleTrend.vue?vue&type=template&id=30616798&scoped=true&lang=pug"
import script from "./GoogleTrend.vue?vue&type=script&lang=js"
export * from "./GoogleTrend.vue?vue&type=script&lang=js"
import style0 from "./GoogleTrend.vue?vue&type=style&index=0&id=30616798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30616798",
  null
  
)

export default component.exports